import React from "react";
import PropTypes from "prop-types";

import { Box } from "@/components/Atoms/Box";

import theme from "@/foundation/Theme";

function Divider(Props) {
  const {
    variant = "HORIZONTAL",
    color = theme.colorsV2.gray.shade_200,
    height = "0px",
    borderWidth = "1px",
    margin = "0px",
    style,
  } = Props;

  if (variant === "HORIZONTAL") {
    return (
      <>
        <Box>
          <hr
            style={{
              height: height,
              borderWidth: borderWidth,
              color: color,
              backgroundColor: color,
              margin: margin,
              ...style,
            }}
          ></hr>
        </Box>
      </>
    );
  } else if (variant === "VERTICAL") {
    return (
      <Box
        style={{
          borderLeft: `${borderWidth} solid ${color} `,
          height: "100%",
          ...style,
        }}
      ></Box>
    );
  } else {
    return <></>;
  }
}

export default Divider;

Divider.propTypes = {
  variant: PropTypes.oneOf(["HORIZONTAL", "VERTICAL"]),
};
